import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = "/api";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as any;
      const token = state.auth?.token;

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      if (!headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
      }
      return headers;
    },
  }),
  tagTypes: [
    "schools",
    "getdashboardData",
    "stats",
    "staffInsights",
    "dashboardAll",
    "monthly-assessment",
    "staffPermission",
    "staffList",
    "questionaire",
    "defaultQuestionSet",
    "userPendingReviews",
    "reviewees",
    "staffAssessments",
    "staffProfile",
    "previousAssessments",
    "reviews",
    "reviewee",
    "highestQualification",
    "getBispokeFilters",
    "staffGrade",
    "designation",
    "staffResponsibility",
    "FilterSetData",
  ],
  endpoints: () => ({}),
});
